import { Box, Typography } from "@mui/material";
import { useIntl } from 'react-intl';

export default function ChartTooltip({
  active,
  payload,
  label,
  value,
  valueFormatter,
  secondaryText,
  disableLabel = false,
  labelName,
}) {
  const intl = useIntl();
  const payloadValue = payload?.[0]?.value;
  const tooltipValue = value ?? payloadValue;
  const resolvedLabelName = labelName === undefined
    ? intl.formatMessage({ id: 'dashboard.new.operation.tickets' })
    : labelName;

  if (!active || tooltipValue === undefined || tooltipValue === null) {
    return null;
  }

  const formattedValue = typeof valueFormatter === 'function'
    ? valueFormatter(tooltipValue)
    : tooltipValue;

  return (
    <Box
      sx={{
        bgcolor: '#ffffff',
        border: '1px solid #e5e7eb',
        borderRadius: 1.5,
        px: 1.5,
        py: 1,
        boxShadow: '0 8px 20px rgba(15, 23, 42, 0.12)',
        zIndex: 4
      }}
    >
      {label && !disableLabel && (
        <Typography
          sx={{
            fontSize: 12,
            color: '#64748b',
            mb: 0.5,
          }}
        >
          {label}
        </Typography>
      )}

      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 700,
          color: '#1f2937',
        }}
      >
        {formattedValue}
        {resolvedLabelName ? ` ${resolvedLabelName}` : ''}
      </Typography>

      {secondaryText && (
        <Typography
          sx={{
            mt: 0.25,
            fontSize: 12,
            color: '#64748b',
          }}
        >
          {secondaryText}
        </Typography>
      )}
    </Box>
  );
}
